module.exports = __webpack_public_path__ + "img/log3.87ff9841.png";